export enum OsmType {
  NODE = 'node',
  WAY = 'way',
  RELATION = 'relation',
  POLYGON = 'polygon',
}
